import { Component, OnInit } from '@angular/core';
import { UserFormMode, UserFormComponent } from '../../components/user-form/user-form.component';

@Component({
    selector: 'app-capture-admin-user-new',
    templateUrl: './capture-admin-user-new.component.html',
    styleUrls: ['./capture-admin-user-new.component.scss'],
    imports: [UserFormComponent]
})
export class CaptureAdminUserNewComponent implements OnInit {
  userFormModes = UserFormMode;

  constructor() {}

  ngOnInit() {}
}
